<template>
  <div v-bind:class="{inActive: !user.is_active}">
    <p>{{ user.name }} ({{ user.id }})
      <template v-if="getDetailByAlias(user, 'telegram_chat_data')">
        <i class="icon-fa icon-fa-paper-plane color_blue"></i>
      </template>
    </p>
    <p class="phone">{{ user.phone }}</p>
    <p class="comment" v-if="getDetailByAlias(user, 'comment')">{{ getDetailByAlias(user, 'comment') }}</p>
  </div>
</template>

<script>
export default {
  props: ['user'],
  methods: {
    getDetailByAlias(user, alias) {
      let value = false;
      user.details.forEach((d) => {
        if (d.alias === alias) {
          value = d.details;
        }
      });
      if (!value) {
        value = false;
      }
      return value;
    }
  }
}
</script>

<style scoped>
i.color_blue {
  color: #5BBFDE;
}

.inActive {
  color: #b1b1b1;
}

p {
  margin-bottom: 2px;
}

.comment {
  font-size: 11px;
}
</style>
